import { Icon } from '@chakra-ui/react';

export const ChoiceQuestion = (props) => (
  <Icon viewBox="0 0 20 20" boxSize="16px" color="icon.g1" {...props}>
    <path
      d="M13.75 7.96283L12.8687 7.0835L8.75 11.1644L7.1375 9.57288L6.25 10.446L8.75 12.9168L13.75 7.96283Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.81481 3.3335H15.1852C16 3.3335 16.6667 4.00016 16.6667 4.81498V15.1853C16.6667 16.0002 16 16.6668 15.1852 16.6668H4.81481C4 16.6668 3.33333 16.0002 3.33333 15.1853V4.81498C3.33333 4.00016 4 3.3335 4.81481 3.3335ZM4.81481 15.1853H15.1852V4.81498H4.81481V15.1853Z"
      fill="currentColor"
    />
  </Icon>
);
